import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IHXTobaccoInfo } from 'src/app/models/IChiefStatement';

@Component({
  selector: 'app-hx-tobacco-history',
  templateUrl: './hx-tobacco-history.component.html',
  styleUrls: ['./hx-tobacco-history.component.css']
})
export class HxTobaccoHistoryComponent implements OnInit {
  lstHXTobaccoInfo: IHXTobaccoInfo;
  tobaccoHistory: string = '';
  noofCigerettes: string = '';
  yearsusingTobacco: string = '';
  ceasedSmoking: string = '';
  constructor(public dialogRef: MatDialogRef<HxTobaccoHistoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IHXTobaccoInfo) { }

  ngOnInit() {
    this.lstHXTobaccoInfo = this.data;
    this.tobaccoHistory = (this.lstHXTobaccoInfo.tobaccoHistory != '' && this.lstHXTobaccoInfo.tobaccoHistory != undefined) ? this.lstHXTobaccoInfo.tobaccoHistory : ' No Data';
    this.noofCigerettes = (this.lstHXTobaccoInfo.noofCigarettes != '' && this.lstHXTobaccoInfo.noofCigarettes != undefined) ? this.lstHXTobaccoInfo.noofCigarettes : ' No Data';
    this.yearsusingTobacco = (this.lstHXTobaccoInfo.tobaccoYears != '' && this.lstHXTobaccoInfo.tobaccoYears != undefined) ? this.lstHXTobaccoInfo.tobaccoYears : ' No Data';
    this.ceasedSmoking = (this.lstHXTobaccoInfo.dateCeased != '' && this.lstHXTobaccoInfo.dateCeased != undefined) ? this.lstHXTobaccoInfo.dateCeased : ' No Data';
  }
  onDismiss(): void {
    // Close the dialog, return false
    this.dialogRef.close(false);
  }
}
